module.exports = __webpack_public_path__ + "img/43.bd158946.svg";